import { Icon } from "@iconify/react/dist/iconify.js";

const Footer = () => {
    return (
        <>
            <a
                href="#contact-form"
                className="bg-primary button-primary bottom-2 sticky z-[999] max-w-[275px] ml-auto mr-14 maxMd:py-3"
            >
                <p>Zapytaj o mieszkanie</p>
            </a>
            <div className="pt-12 maxMd:pt-6"></div>
            <footer className="bg-primary px-14 mb:px-8 maxMd:px-4 py-10 flex flex-col gap-8">
                <img
                    src="/storage/static/unidevelopment-logo-white.svg"
                    alt="Logo Unidevelopment"
                    width={281}
                    height={37}
                    className="w-[281px] h-auto"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-8 xl:gap-6 w-full">
                    <div className="flex flex-col gap-1">
                        <a
                            download={true}
                            href="/PI_kuso_A.pdf"
                            className="font-extrabold text-white text-p leading-p tracking-p"
                        >
                            Prospekt Budynek A
                        </a>
                        <a
                            download={true}
                            href="/PI_kuso_B.pdf"
                            className="font-extrabold text-white text-p leading-p tracking-p"
                        >
                            Prospekt Budynek B
                        </a>
                    </div>

                    <div className="flex flex-col gap-1">
                        <p className="font-extrabold text-white text-p leading-p tracking-p">
                            UNI 4 sp. z o.o.
                        </p>
                        <p className="text-white text-label leading-label tracking-small">
                            03-285 Warszawa ul. Ludwika
                            <br />
                            Kondratowicza 37
                        </p>
                    </div>

                    <div className="flex flex-col gap-1">
                        <p className="font-extrabold text-white text-p leading-p tracking-p">
                            Podmiot rejestrujący:
                            <br />
                            Sąd Rejonowy dla m. st. Warszawy w Warszawie
                        </p>
                        <p className="text-white text-label leading-label tracking-small">
                            KRS: 886543
                        </p>
                        <p className="text-white text-label leading-label tracking-small">
                            NIP: 5242914605
                        </p>
                        <p className="text-white text-label leading-label tracking-small">
                            REGON: 388347036
                        </p>
                    </div>

                    <div className="flex flex-col gap-1">
                        <p className="font-extrabold text-white text-p leading-p tracking-p">
                            Inspektor Ochrony Danych
                        </p>
                        <p className="text-white text-label leading-label tracking-small">
                            w Unidevelopment S.A.:
                        </p>
                        <p className="font-extrabold text-white text-p leading-p tracking-p">
                            Jakub Wezgraj
                        </p>
                        <a
                            href="mailto:ochronadanych@unidevelopment.pl"
                            title="ochronadanych@unidevelopment.pl"
                            className="text-white text-label leading-label tracking-small underline"
                        >
                            ochronadanych@unidevelopment.pl
                        </a>
                    </div>
                </div>

                <div className="flex flex-wrap items-center justify-between gap-6 w-full">
                    <div className="flex flex-wrap gap-x-16 gap-y-3">
                        <a
                            href="/polityka-prywatnosci-kusocinskiego.pdf"
                            target="_blank"
                            rel="noreferrer"
                            title="Polityka prywatności"
                            className="text-white text-p leading-p tracking-p underline"
                        >
                            Polityka prywatności
                        </a>
                        <a
                            href="/polityka-cookie-kusocinskiego.pdf"
                            target="_blank"
                            rel="noreferrer"
                            title="Polityka plików cookies"
                            className="text-white text-p leading-p tracking-p underline"
                        >
                            Polityka plików cookies
                        </a>
                    </div>

                    <div className="flex gap-4 items-center">
                        <a
                            href="https://pl-pl.facebook.com/Unidevelopment/"
                            target="_blank"
                            rel="noreferrer"
                            title="Facebook"
                            className="text-white hover:opacity-80 transition-opacity"
                        >
                            <Icon
                                icon="ic:baseline-facebook"
                                width={32}
                                height={32}
                            />
                        </a>
                        <a
                            href="https://www.instagram.com/unidevelopment_sa/"
                            target="_blank"
                            rel="noreferrer"
                            title="Instagram"
                            className="text-white hover:opacity-80 transition-opacity"
                        >
                            <Icon
                                icon="ri:instagram-fill"
                                width={32}
                                height={32}
                            />
                        </a>
                        <a
                            href="https://pl.linkedin.com/company/unidevelopment"
                            target="_blank"
                            rel="noreferrer"
                            title="LinkedIn"
                            className="text-white hover:opacity-80 transition-opacity"
                        >
                            <Icon
                                icon="mdi:linkedin"
                                width={32}
                                height={32}
                            />
                        </a>
                    </div>
                </div>

                <p className="text-4 leading-[18px] text-white tracking-[0.35px]">
                    Zamieszczone na stronie opisy i wizualizacje nie stanowią
                    oferty w rozumieniu prawa i opublikowane są w celach
                    informacyjnych
                </p>
            </footer>
        </>
    );
};

export default Footer;
